// this file origin from Winningtemp.Shared

import SimpleDropdownSelect from "./SimpleDropdownSelect";

export default SimpleDropdownSelect;